var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJichuJiagou(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8 2.6a.1.1 0 01.1-.1h4.3a.1.1 0 01.1.1v2.8a.1.1 0 01-.1.1H5.9a.1.1 0 01-.1-.1V2.6zM2.3 10.6a.1.1 0 01.1-.1h4.3a.1.1 0 01.1.1v2.8a.1.1 0 01-.1.1H2.4a.1.1 0 01-.1-.1v-2.8zM9.3 10.6a.1.1 0 01.1-.1h4.3a.1.1 0 01.1.1v2.8a.1.1 0 01-.1.1H9.4a.1.1 0 01-.1-.1v-2.8z",
    stroke: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6v2M4.5 10.5V8.1a.1.1 0 01.1-.1h6.8a.1.1 0 01.1.1v2.4",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "static/jichu_jiagou.a42a717d.svg";
export { SvgJichuJiagou as ReactComponent };